module.exports = __webpack_public_path__ + "img/156.0b19956d.png";